export default __webpack_public_path__ + "static/media/iconMinusBlack.6c9b4239.svg";